<h1 style="padding-left: 25px;">RegScale Software Bill of Materials</h1>

<p style="font-size: medium; padding-left: 25px;">
    An SBOM, or Software Bill of Materials, is a comprehensive inventory or list of all components, libraries, and dependencies used in a software product. It includes information about each component, such as its name, version, licensing, and the supplier or origin. An SBOM serves as a transparent record of the software's composition, making it easier to track and manage components, understand potential security risks, and comply with licensing requirements.<br/>
</p>

<p style="font-size: medium; padding-left: 25px;">
    A complete list of RegScale packages is provided below which comprises the current SBOM (includes both Core Platform and Command Line Interface (CLI)):<br/>
</p>

<h2 style="padding-left: 25px;">Total Packages: {{ sbom.length }}</h2>

<div class="card" style="margin-top: 75px;" *ngFor="let s of sbom; let i = index">
  <div class="card-header"><h3>{{ i + 1 }} - {{ s.name }} - {{ s.version }}</h3></div>
  <div class="card-body">
    <p *ngIf="s.description">Description: {{ s.description }}</p>
    <p>Package URL: {{ s.purl }}</p>
    <p *ngIf="s.publisher">Publisher: {{ s.publisher }}</p>
    <p *ngIf="s.type">Package Type: {{ s.type }}</p>
    <p *ngIf="s.copyright">Copyright: {{ s.copyright }}</p>
    <p *ngIf="s.license">License: {{ s.license }}</p>
    <div *ngIf="s.externalReferences">
        <p *ngFor="let l of s.externalReferences; let li = index;">Link{{ li + 1 }}: <a [href]="l.url" target="_blank">{{ l.url }}</a></p>
    </div>
  </div>
</div>
